// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1rSPh","productName":"Table_productName__NB4dx"};